import gql from 'graphql-tag';
import { Fragments } from '@shared/api/fragments';

export const snooze = gql`
  mutation SnoozeUserMutation($until: DateTime) {
    snoozeUser(input: { until: $until }) {
      user {
        id
        snoozeUntil
      }
    }
  }
`;

export const resendInvite = gql`
  mutation ResendInviteMutation($businessId: Int!, $userIds: [Int]!) {
    sendWelcomes(input: { businessId: $businessId, userIds: $userIds }) {
      users {
        id
        lastRemindedAt
      }
    }
  }
`;

export const updateNotificationSettings = gql`
  mutation UpdateUserNotificationSettingsMutation($notificationSettings: NotificationType!) {
    updateUserNotification(input: { notificationSettings: $notificationSettings }) {
      user {
        id
        notificationSettings
      }
    }
  }
`;

export const resetNotificationSettings = gql`
  mutation ResetNotificationSettingsMutation {
    resetUserNotificationsPreference {
      user {
        id
        notificationSettings
      }
    }
  }
`;

export const create = gql`
  mutation CreateUserMutation(
    $businessId: Int!
    $firstName: String!
    $lastName: String
    $phoneNumber: String
    $email: String
  ) {
    createUser(
      input: {
        user: {
          businessId: $businessId
          firstName: $firstName
          lastName: $lastName
          phoneNumber: $phoneNumber
          email: $email
        }
      }
    ) {
      user {
        ...ShortUser
      }
    }
  }

  ${Fragments.user.short}
`;

export const updateRole = gql`
  mutation UpdateUserRoleMutation($businessId: Int!, $userId: Int!, $role: BusinessRole) {
    updateUserRole(businessId: $businessId, userId: $userId, role: $role) {
      user {
        ...DirectoryUser
      }
    }
  }

  ${Fragments.user.directoryUser}
`;

export const update = gql`
  mutation UpdateUserMutation(
    $imageUrl: String
    $firstName: String!
    $lastName: String
    $phoneNumber: String
    $email: String
  ) {
    updateUser(
      input: {
        img: $imageUrl
        firstName: $firstName
        lastName: $lastName
        phoneNumber: $phoneNumber
        email: $email
      }
    ) {
      user {
        ...User
        ...PersonalDetailsUser
      }
    }
  }

  ${Fragments.user.normal}
  ${Fragments.user.personalDetails}
`;

export const updateV2 = gql`
  mutation UpdateUserV2Mutation($input: UpdateUser!) {
    updateUserV2(input: $input) {
      id
      firstName
      lastName
      fullName
      email
      phoneNumber
      imageUrl
    }
  }
`;

export const registerPushToken = gql`
  mutation RegisterPushTokenMutation(
    $source: PushTokenSource!
    $stringifiedOneSignalPayload: String!
  ) {
    addUserPushToken(input: { source: $source, token: $stringifiedOneSignalPayload }) {
      success
    }
  }
`;

export const removePushToken = gql`
  mutation RemovePushTokenMutation(
    $source: PushTokenSource!
    $stringifiedOneSignalPayload: String!
  ) {
    removeUserPushToken(input: { source: $source, token: $stringifiedOneSignalPayload }) {
      success
    }
  }
`;

export const createUserGroup = gql`
  mutation CreateUserGroupMutation($name: String!, $handle: String!) {
    createUserGroup(input: { name: $name, handle: $handle }) {
      id
      name
      handle
      businessId
      createdAt
      updatedAt
    }
  }
`;

export const updateUserGroup = gql`
  mutation UpdateUserGroupMutation($input: UpdateUserGroup!) {
    updateUserGroup(input: $input) {
      ...UserGroup
    }
  }

  ${Fragments.user.userGroup}
`;

export const deleteUserGroup = gql`
  mutation DeleteUserGroupMutation($id: UUID!) {
    deleteUserGroup(id: $id)
  }
`;

export const createUserGroupUserAssociations = gql`
  mutation CreateUserGroupUserAssociationsMutation($input: [CreateUserGroupUserAssociation!]!) {
    createUserGroupUserAssociations(input: $input) {
      ...UserGroupUserAssociation
    }
  }

  ${Fragments.user.userGroupUserAssociation}
`;

export const deleteUserGroupUserAssociation = gql`
  mutation DeleteUserGroupUserAssociationMutation($input: DeleteUserGroupUserAssociation!) {
    deleteUserGroupUserAssociation(input: $input)
  }
`;
